<div class="container">
  <section class="form-tasklist">
    <mat-accordion
      class="example-headers-align"
      *ngFor="let training of listTraining"
    >
      <mat-expansion-panel
        [expanded]="step === training.trainingQuizNumber"
        (opened)="setStep(training.trainingQuizNumber)"
        
      >
        <br />
        <mat-expansion-panel-header >
          <mat-panel-title >
            <div >
              <mat-icon [ngClass]="quizsectionStatus(training.isPassed)"><div [innerHTML]="loadTaskStatusIconHtml(training.isPassed, training.trainingQuizNumber)"></div></mat-icon>
            </div>
            
            <strong> {{ training.sectionHeading }}</strong>
          
          </mat-panel-title>

          <ng-template #closedIcon *ngIf="hideToggle"></ng-template>
         
        </mat-expansion-panel-header>

        <div class="accordion-content on" role="region" aria-hidden="false" id="accordion-content-{{training.trainingQuizNumber}}"  [attr.aria-disabled]="false"  [attr.aria-label]="'accordion-' + training.trainingQuizNumber"
       style="display: block;">
          <h4>{{ training.sectionTitle }}</h4>
          <div [innerHTML]="training.sectionText"></div>
          <br />
          <div class="video-container">
            <div fxLayout="row" fxLayout.lt-md="column wrap" fxLayoutGap="25px">
           
              <div fxFlex="50%">
            <div class="video-content-normal">
              <p  [innerHTML]="training.videoText"></p>
              <div *ngIf="training.videoUrl !==null && training.videoUrl.length > 0"> <p >
                <a  mat-stroked-button color="primary"
                  (click)="openModal(training.videoUrl)"
                >
                  {{ training.watchButtonText }}</a></p>
              </div>
              
              <p [innerHTML]="training.pdfText" style="padding-top: 10px;"></p>
              <div *ngIf="training.pdfUrl.length > 0">
                   
                    
                    
                <p>
                  <a mat-stroked-button color="primary"  
                  href="{{training.pdfUrl}}"
                  target="_blank" 
                  id="{{training.pdfViewText}}-{{training.trainingQuizNumber}}"
                  [attr.aria-disabled]="false"
                  [attr.aria-label]="training.trainingQuizNumber"
                  >{{training.pdfViewText}}</a>
               
                
                </p>
              </div>
              <div
              *ngIf="
                training.trainingFile.length > 0 &&
                currentUser?.isContractor === true &&
                training.isshowQuiz ===true
              "
            >
              <p>
                <a
                mat-stroked-button color="primary"
                  (click)="openquiz(training.trainingQuizNumber)"
                  [attr.aria-label]="'Take the Quiz--' + training.trainingQuizNumber"
                  data-quiz-id="{{training.id}}"
                  data-quiz-number="{{training.trainingQuizNumber}}"
                >
                  Take the Quiz </a
                ><br />&nbsp;
              </p>
            </div>
            <div
              *ngIf="
                currentUser?.isContractor === true && training.isPassed ===true
              "
            >
              <span
                class="quiz-pass"
                style="color: #3c763d; font-weight: bold;"
                >Congratulations! You passed the quiz!</span
              >
            </div>

            <div
              *ngIf="
                currentUser?.isContractor === true && training.isPassed ===false
              "
            >
              <span class="quiz-fail" style="color: #f44336; float: left;"
                >Please re-take the quiz to complete this section.</span
              >
            </div>
            <div *ngIf="
            currentUser?.isContractor === true && training.isPassed === null && training.isshowQuiz ===false
          "
        
               >
            <span class="quiz-fail" style="color: #f44336; float: left;"
              >Please complete the previous section(s) of the Quiz.</span
            >
          </div>
            </div></div>
            <div fxFlex="50%">
            <div *ngIf="training.videoTeaserImage.length > 0">
                <div class="video-embed">
                  <a
                    (click)="openModal(training.videoUrl)"
                    data-glightbox="gallery"
                    class="videoBox"
                  >
                    <div class="icon">
                      <i class="fa-thin fa-circle-play"></i>
                    </div>
                    <img
                     class="video-teaser"
                      src="{{training.videoTeaserImage}}"
                      [attr.aria-label]="'video-teaser image--' + training.trainingQuizNumber"
                      alt="Image-{{training.trainingQuizNumber}}"
                    />
                  </a>
                </div>
              </div>
              </div>
          </div>
           
            </div>

        
        </div>
        <div *ngIf="
        currentUser?.isContractor !== true"  [innerHTML]="training.bottomSectionText"></div>

      </mat-expansion-panel>
      <app-video-popup
        *ngIf="showPopup"
        [videoUrl]="currentVideoUrl"
      ></app-video-popup>

    <br>
    </mat-accordion>
  </section>
</div>
